import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@verantos-dev/app-state-base';

import { DEFAULT_MODEL_VERSION } from './researchAssistantSlice';

// Base state selector
const selectResearchAssistantState = (state: RootState) => state.researchAssistant;

export const selectResearchAssistantIsWaitingForResponse = createSelector(
  selectResearchAssistantState,
  (state) => state?.isProcessing
);

export const selectResearchAssistantIsReady = createSelector(
  selectResearchAssistantState,
  (state) => state?.isReady
);

export const selectResearchAssistantMessages = createSelector(
  selectResearchAssistantState,
  (state) => state?.messages
);

export const selectResearchAssistantModel = createSelector(
  selectResearchAssistantState,
  (state) => state?.model || DEFAULT_MODEL_VERSION
);
